import { SVGProps } from 'react';

export const RefreshTW = (props: SVGProps<SVGSVGElement>) => (
  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.6773 1.32187C6.86116 0.50625 5.74109 0 4.49719 0C2.00938 0 0 2.01375 0 4.5C0 6.98625 2.00938 9 4.49719 9C6.59662 9 8.34709 7.56563 8.84803 5.625H7.6773C7.21576 6.93563 5.96623 7.875 4.49719 7.875C2.63415 7.875 1.12007 6.36188 1.12007 4.5C1.12007 2.63812 2.63415 1.125 4.49719 1.125C5.43152 1.125 6.26454 1.51312 6.87242 2.12625L5.06004 3.9375H9V0L7.6773 1.32187Z" fill="#0076C0" />
  </svg>

);
